import { normalizeString } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_MAINTENANCE_BANNER = createFcmConfig('maintenance_banner', {
	normalizer: normalizeString,
	defaultValue: undefined,
});
